<i18n lang='yml' src='../i18n/Import.yml'></i18n>

<template>
    <div class='row'>
        <div class='col-md-4'>
            <div class='form-group'>
                <label for='import-network'>{{ $t('network')}}</label>
                <select id='import-network' class='form-control' v-model='selectedNetwork' v-on:change='selectNetwork'>
                    <option v-for='network in networks' :value='network.id'>
                        {{ network.name }}
                    </option>
                </select>
            </div>
        </div>
        <div class='col-md-4'>
            <div class='form-group'>
                <label for='import-container-type'>{{ $t('container_type')}}</label>
                <select id='import-container-type' class='form-control' v-model='selectedContainerType' v-on:change='selectContainerType'>
                    <option v-for='containerType in containerTypes' :value='containerType.id'>
                        {{ containerType.name }}
                    </option>
                </select>
            </div>
        </div>
        <div class='col-md-4'>
            <div class='form-group'>
                <label for='import-container'>{{ $t('container')}}</label>
                <select id='import-container' class='form-control' name='import_container_id' v-model='selectedContainer' @click="$emit('selected', selectedContainer)">
                    <option v-for='container in containers' :value='container.id'>
                        {{ container.name }}
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            locale: { type: String },
            networks: { type: Array },
            endpoint: { type: String },
            networkId: { type: Number },
            containerTypeId: { type: Number },
            containerId: { type: Number },
        },
        data: function () {
            return {
                containerTypes: [],
                containers: [],
                selectedNetwork: this.networkId || -1,
                selectedContainerType: this.containerType || -1,
                selectedContainer: this.containerId || -1
            }
        },
        mounted: function () {
            this.$i18n.locale = this.locale;
        },
        methods: {
            selectNetwork: function () {
                this.containerTypes = [
                    { id: -1, name: this.$i18n.t('loading') }
                ];
                this.selectedContainerType = -1;
                this.containers = [
                    { id: -1, name: this.$i18n.t('loading') }
                ];
                this.selectedContainer = -1;

                const self = this;
                $.ajax({
                    url: this.endpoint,
                    data: {
                        network_id: self.selectedNetwork
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.containerTypes = data;
                        self.containers = [];
                    },
                    error: function (error) {
                        console.log(error);
                        self.containerTypes = [];
                        self.containers = [];
                    }
                });
            },
            selectContainerType: function () {
                this.containers = [
                    { id: -1, name: this.$i18n.t('loading') }
                ];
                this.selectedContainer = -1;

                const self = this;
                $.ajax({
                    url: this.endpoint,
                    data: {
                        network_id: self.selectedNetwork,
                        container_type_id: self.selectedContainerType
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.containers = data;
                    },
                    error: function (error) {
                        console.log(error);
                        self.containers = [];
                    }
                });
            }
        }
    }
</script>
